import {formatMoney} from "./theme.js"

var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

$('body').delegate('.custom_quantity_select_checkbox','change',function(){
  if($(this).is(':checked')){
    $(this).parent().prev().css('display','block')
    $(this).parent().parent().prev().find('.quantity-selector').css('display','none')
    $(this).parent().prev().find('.custom_quantity_select').prop('disabled',false)
    $(this).parent().parent().prev().find('.qnty_impact').prop('disabled',true)
    var newcheckquantity = $(this).closest('.product-info').find('.custom_quantity_select').val()
    setTimeout(()=>{
      let newcheckurlParams = new URLSearchParams(window.location.search);
      let newcheckvariant_id = newcheckurlParams.get("variant");
      if(newcheckvariant_id == null){
        newcheckvariant_id = $('.getvariantprice').data('getvariantid')
      }
      var newcheckgetprice = 0;
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+$('.getvariantprice').data('getproducthandle')+'.js', function(product) {
      for(let variant of product.variants){
        if(variant.id == newcheckvariant_id){
         newcheckgetprice = variant.price
        }
      }
      }).done(function(){
        var newcheck_total = newcheckgetprice*newcheckquantity
        $('.right_side_wrap_total').text(formatMoney(newcheck_total, '${{amount}} USD'))
      })
    },100) 
  }else{
    $(this).parent().prev().css('display','none')
    $(this).parent().parent().prev().find('.quantity-selector').css('display','inline-flex')
    $(this).parent().prev().find('.custom_quantity_select').prop('disabled',true)
    $(this).parent().parent().prev().find('.qnty_impact').prop('disabled',false)
    var checkquantity = $(this).closest('.product-info').find('.qnty_impact').val()
    setTimeout(()=>{
      let checkurlParams = new URLSearchParams(window.location.search);
      let checkvariant_id = checkurlParams.get("variant");
      if(checkvariant_id == null){
        checkvariant_id = $('.getvariantprice').data('getvariantid')
      }
      var checkgetprice = 0;
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+$('.getvariantprice').data('getproducthandle')+'.js', function(product) {
      for(let variant of product.variants){
        if(variant.id == checkvariant_id){
         checkgetprice = variant.price
        }
      }
      }).done(function(){
        var check_total = checkgetprice*checkquantity
        $('.right_side_wrap_total').text(formatMoney(check_total, '${{amount}} USD'))
      })
  },100) 
  }
})

$('body').delegate('.custom_variant_check','change',function(){
  if($('.custom_quantity_select_checkbox').is(':checked')){
    var getquantity = $(this).closest('.product-info').find('.custom_quantity_select').val()
  }else{
    var getquantity = $(this).closest('.product-info').find('.qnty_impact').val()
  }
  setTimeout(()=>{
      let urlParams = new URLSearchParams(window.location.search);
      let variant_id = urlParams.get("variant");
      var newgetprice = 0;
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+$('.getvariantprice').data('getproducthandle')+'.js', function(product) {
      for(let variant of product.variants){
        if(variant.id == variant_id){
         newgetprice = variant.price
        }
      }
      }).done(function(){
        var get_total = newgetprice*getquantity
        $('.right_side_wrap_total').text(formatMoney(get_total, '${{amount}} USD'))
      })
  },100) 
})

$('body').delegate('.custom_quantity-selector__button','click',function(){
  var quantity_new = $(this).parent().find('.qnty_impact').val()
  // $('#getvariantprice').load(' #getvariantprice')
  // var getprice = $(this).closest('.product-info').find('.getvariantprice:first').text()
  // var new_total = parseInt(getprice)*quantity_new
  // $('.right_side_wrap_total').text(formatMoney(new_total, '${{amount}} USD'))
  setTimeout(()=>{
      let urlParams = new URLSearchParams(window.location.search);
      let variant_id = urlParams.get("variant");
      if(variant_id == null){
        variant_id = $('.getvariantprice').data('getvariantid')
      }
      var getprice = 0;
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+$('.getvariantprice').data('getproducthandle')+'.js', function(product) {
      for(let variant of product.variants){
        if(variant.id == variant_id){
         getprice = variant.price
        }
      }
      }).done(function(){
        var get_total = getprice*quantity_new
        $('.right_side_wrap_total').text(formatMoney(get_total, '${{amount}} USD'))
      })
  },100)
  
})

$('body').delegate('.custom_quantity_select','change',function(){
  var selectquantity = $(this).closest('.product-info').find('.custom_quantity_select').val()
    setTimeout(()=>{
      let selecturlParams = new URLSearchParams(window.location.search);
      let selectvariant_id = selecturlParams.get("variant");
      if(selectvariant_id == null){
        selectvariant_id = $('.getvariantprice').data('getvariantid')
      }
      var selectgetprice = 0;
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+$('.getvariantprice').data('getproducthandle')+'.js', function(product) {
      for(let variant of product.variants){
        if(variant.id == selectvariant_id){
         selectgetprice = variant.price
        }
      }
      }).done(function(){
        var select_total = selectgetprice*selectquantity
        $('.right_side_wrap_total').text(formatMoney(select_total, '${{amount}} USD'))
      })
    },100) 
})